import { SiteHeader } from '../components/site-header'
import { useHeaderVariant, useShowHeaderBorder } from '../hooks/useHeaderVariant'
import { HeaderActionsContainer } from './HeaderActionsContainer'
import { LogoContainer } from './LogoContainer'
import { MobileDrawerContainer } from './MobileDrawerContainer'
import { NavigationContainer } from './NavigationContainer'

export const SiteHeaderContainer = () => {
    const variant = useHeaderVariant()
    const showBorder = useShowHeaderBorder()

    return (
        <>
            <SiteHeader
                variant={variant}
                showBorder={String(showBorder)}
                logo={<LogoContainer />}
                navigation={<NavigationContainer />}
                actions={<HeaderActionsContainer />}
            />
            <MobileDrawerContainer />
        </>
    )
}
